import { Carousel } from '@vp/swan';
import { __ } from '@99designs/i18n';

interface RecommendationsCarouselProps {
    children: React.ReactNode;
}

export function RecommendationsCarousel({ children }: RecommendationsCarouselProps) {
    return (
        <Carousel
            slidesToShow={{ xs: 2, sm: 4, lg: 6 }}
            slidesToScroll={2}
            infinite={false}
            gridGutters
            accessibleTextForPrevious={__('Go to previous slide')}
            accessibleTextForNext={__('Go to next slide')}
            arrowVerticalOffset="-17px"
            key="recommendations-carousel"
        >
            {children}
        </Carousel>
    );
}
